import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import AdsGenerationIcon from "../../../assets/Dashboard/icons/AdsGenerationIcon";
import ImageEditingIcon from "../../../assets/Dashboard/icons/ImageEditingIcon";
import ImageGenerationIcon from "../../../assets/Dashboard/icons/ImageGenerationIcon";
import ModelsIcon from "../../../assets/Dashboard/icons/ModelsIcon";
import ProductShotIcon from "../../../assets/Dashboard/icons/ProductShotIcon";
import TgIcon from "../../../assets/Dashboard/icons/TgIcon";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";
import useSecureNavigate from "../../../hooks/useSecureNavigate";
import DashboardWidget from "../Widget/DashboardWidget";
import ProductWidgetCards, { ProductsWidgetCardProps } from "./Cards/ProductsWidgetCards";
import ProductsWidgetIntegrations from "./Integrations/ProductsWidgetIntegrations";
import styles from "./ProductsWidget.module.scss";

type Props = {
	className?: string;
};

const ProductsWidget = ({ className }: Props) => {
	const { t } = useTranslation("dashboard", { keyPrefix: "products" });
	const navigate = useSecureNavigate();

	const productsCards: ProductsWidgetCardProps[] = [
		{
			icon: <ModelsIcon />,
			header: t("cards.models.header"),
			description: t("cards.models.description"),
			docsLink: LinkConstants.INTEGRATIONS.HUGGING_FACE,
			onClick: () => navigate(RouterConstants.MODELS.fullPath),
		},
		{
			icon: <ImageGenerationIcon />,
			header: t("cards.imageGeneration.header"),
			description: t("cards.imageGeneration.description"),
			docsLink: LinkConstants.IMAGE_GENERATION.OVERVIEW,
			onClick: () => navigate(RouterConstants.IMAGE_GENERATION.fullPath),
		},
		{
			icon: <ImageEditingIcon />,
			header: t("cards.imageEditing.header"),
			description: t("cards.imageEditing.description"),
			docsLink: LinkConstants.IMAGE_EDITING.OVERVIEW,
			onClick: () => navigate(RouterConstants.IMAGE_EDITING.fullPath),
		},
		{
			icon: <TgIcon />,
			header: t("cards.tailoredGeneration.header"),
			description: t("cards.tailoredGeneration.description"),
			docsLink: LinkConstants.TG.OVERVIEW,
			onClick: () => navigate(RouterConstants.NEW_TG.fullPath),
		},
		{
			icon: <ProductShotIcon />,
			header: t("cards.productShot.header"),
			description: t("cards.productShot.description"),
			docsLink: LinkConstants.PRODUCT_SHOT.OVERVIEW,
			onClick: () => navigate(RouterConstants.PRODUCT_SHOT.fullPath),
		},
		{
			icon: <AdsGenerationIcon />,
			header: t("cards.adsGeneration.header"),
			description: t("cards.adsGeneration.description"),
			docsLink: LinkConstants.ADS_GENERATION.OVERVIEW,
			comingSoonBadge: true,
			// onClick: () => navigate(RouterConstants.ADS_GENERATION.fullPath),
		},
	];

	return (
		<DashboardWidget title={t("title")} className={clsx(styles.widget, className)}>
			<ProductWidgetCards cards={productsCards} />
			<ProductsWidgetIntegrations />
		</DashboardWidget>
	);
};

export default observer(ProductsWidget);
